module.exports = __webpack_public_path__ + "static/022-da0c847a50beb81f8b33bd333b89316f.png";